import React from 'react';

import { AccountPage } from 'screens/Account';
import { CreateUser } from 'screens/CreateUser';
import { LoginPage } from 'screens/Login';
import { NotFoundPage } from 'screens/NotFound';
import { RequireAuth } from 'router/RequireAuth';
import { RequireSubscription } from './RequireSub';
import { RequireUser } from './RequireUser';
import { SubscribePage } from 'screens/Subscribe';
import {
  Navigate,
  Route,
  Routes,
} from 'react-router-dom';


export const Router = () => {
  return (
    <Routes>
      {/*
        Both of these routes go to the login page since they do the same thing.
        Only the submit button text will change
      */}
      <Route path="/signup" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
        path="/subscribe"
        element={<RequireUser reroutePath={'/login'} element={<SubscribePage />} />}
      />
      <Route
        path="/create"
        element={<RequireAuth reroutePath={'/login'} element={<CreateUser />} />}
      />
      <Route
        path="/account"
        element={<RequireSubscription reroutePath={'/subscribe'} element={<AccountPage />} />}
      />
      <Route path="/" element={<Navigate replace to="/account" />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
};
